import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { ResellerListComponent } from "./reseller-list/reseller-list.component";
import { ResellerDetailComponent } from "./reseller-detail/reseller-detail.component";

const routes: Routes = [
  {
    path: "resellers",
    component: ResellerListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "resellers/new",
    component: ResellerDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "resellers/:id",
    component: ResellerDetailComponent,
    canActivate: [AuthGuard],
  },
];

export const ResellersRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/resellers.routes.ts